import React from 'react'
import { connect } from 'react-redux'
import { setGlobalLoading } from 'redux/actions/actionCommon'
import FeatherIcon from 'feather-icons-react';
import { Link } from 'react-router-dom';
import { INTEGRATIONTABLE } from 'components/Integration/pages/IntegrationView/Includes/ConstArray';


function IntegratioTableCard(props) {
    return (
        <div className="d-flex flex-wrap">
            {INTEGRATIONTABLE.map((e, index) =>
                <div className="app-card" key={index}>
                    <Link to={e.href || "#"}>
                        <div className="app-card-content border st-default-rounded-block bg-white">
                            <div className="d-flex flex-wrap  align-items-center justify-content-center">
                                <span className="pad-12 app-integrations-icon">
                                    <FeatherIcon
                                        icon="bar-chart"
                                        size="26"
                                        className="icon text-primary" />
                                </span>
                                <div className="app-header-wrapper heading-md d-flex flex-column justify-content-center text-center">
                                    <p className="integrations-heading">{e.title}</p>
                                    <p className="integrations-desc">{e.sub_title}</p>
                                </div>
                            </div>
                        </div>
                    </Link>
                </div>
            )}
        </div>
    )
}

const getDataFromStore = state => {
    return {
        currentUser: state.auth.currentUser
    };
}

const dispatchActionsToProps = dispatch => {
    return {
        setGlobalLoading: bool => dispatch(setGlobalLoading(bool)),
    }
}

export default connect(getDataFromStore, dispatchActionsToProps)(IntegratioTableCard)